module.exports = __webpack_public_path__ + "img/IMG_8155_L_Black_MockedUp.04119db9.jpg";